import { Typography } from "@mui/material"

type HeaderProps = {
    entityLabel: string;
}

export const Header = ({ entityLabel }: HeaderProps) => {
    return <div>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Custom Fields
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Add custom fields to your {entityLabel.toLowerCase()} forms. These
          fields are stored in metadata.
        </Typography>
    </div>
}
